{
  "title": {
    "tag": "DEC Explorer",
    "title": "Quantify your savings by adopting our solution"
  },
  "intro-text": {
    "1": "Select a photovoltaic plant:",
    "2": "Provide the data:",
    "3": "Your results:"
  },
  "plant-card": {
    "buttons": {
      "select-plant": "Select"
    }
  },
  "form": {
    "fields": {
      "renewableEnergy": {
        "label": "Contracted volume <infoLink> Indicate the amount of annual energy consumption you want to make green by producing Guarantees of Origin with the DEC Energy solution. </infoLink>",
        "error": "Enter a valid value for the contracted volume"
      },
      "goPrice": {
        "label": "GO price <infoLink> Use the slider below or type in the field to indicate the approximate price you are paying for the procurement of Guarantees of Origin. NOTE: you can also enter a value higher than the maximum indicated by the slider. </infoLink>",
        "error": "Enter a valid value for GO price"
      },
      "grayPrice": {
        "label": "Energy price (commodity)<infoLink> Indicate the price you are paying for the procurement of energy (considering only the commodity cost). </infoLink>",
        "error": "Enter a valid value for the energy price"
      },
      "optimistic": {
        "label": "Scenario 1",
        "error": "Enter valid prices for Scenario 1"
      },
      "normal": {
        "label": "Scenario 2",
        "error": "Enter valid prices for Scenario 2"
      },
      "pessimistic": {
        "label": "Scenario 3",
        "error": "Enter valid prices for Scenario 3"
      }
    },
    "back": "Back to plants",
    "submit": "Calculate results",
    "mode": {
      "normal": "Standard",
      "advanced": "Advanced"
    },
    "advanced": {
      "notice": "The advanced version only affects the PDF you receive by email: it compares three scenarios (Scenario 1, 2 and 3) for GO and energy price. The results shown on screen refer to Scenario 1."
    }
  },
  "stepper": ["Select plant", "Enter data", "Result"],
  "result": {
    "inputs-title": "Your inputs",
    "metrics-title": "Key results",
    "inputs": {
      "renewableEnergy": "Contracted volume",
      "goPrice": "GO price",
      "grayPrice": "Energy price (commodity)"
    },
    "metrics": {
      "profits": "Profits + GO",
      "savings": "Energy cost savings",
      "irr": "IRR after tax"
    },
    "irr-note": "* The IRR is shown after tax because the taxes are withheld at source by the producer. The equivalent gross return would amount to {{value}} IRR.",
    "detail": {
      "unlock": {
        "title": "Full results",
        "body": "For free: the year-by-year simulation and the results PDF.",
        "cta": "Get full results",
        "loading": "Unlocking your full results…"
      },
      "resend": {
        "label": "Would you like a PDF with the results of this simulation?",
        "cta": "Resend the PDF"
      },
      "popup": {
        "title": "Access your detailed results",
        "description": "Enter your email in the box below to access the year-by-year simulation and receive the PDF we have prepared for you!",
        "placeholder": "name@company.com",
        "confirm": "Send PDF",
        "sending": "Sending…",
        "emailError": "Please enter a valid email address",
        "error": "Something went wrong. Please try again.",
        "sentTitle": "PDF successfully sent!",
        "sentDescription": "Check your mailbox, the PDF with the detailed results has been sent to your email address. The detailed results are now accessible from this page as well.",
        "sentButton": "Close"
      },
      "booking": {
        "title": "Book a call with us",
        "description": "Get more details about our solution by talking with our experts.",
        "cta": "Book now"
      },
      "chart": {
        "title": "Electricity cost comparison in {{currency}}",
        "red": "Renewable electricity cost purchasing GO",
        "green": "Renewable electricity cost producing GO w/DEC"
      },
      "table": {
        "title": "Financial summary",
        "initialInvestment": "Initial investment (year 0)",
        "profitSold": "Profits (after tax) from energy sales (year 1-{n})",
        "totalNet": "Total net (after tax, year 1-{n})",
        "savings": "Total savings producing GOs (year 1-{n})",
        "total": "Total net (after tax) + total savings",
        "irr": "IRR Equity",
        "irrNote": "The IRR is shown after tax because the taxes are withheld at source by the producer. The equivalent gross return would amount to {{value}} IRR.",
        "breakEven": "Cash flow break-even",
        "breakEvenNote": "The break-even is shown after tax because the taxes are withheld at source by the producer. The equivalent gross break-even would be {{value}}.",
        "na": "N/A"
      },
      "yearTable": {
        "title": "Year-by-year detail",
        "year": "Renting photovoltaic panels w/ DEC (in {{currency}})",
        "start": "Initial",
        "initialInvestment": "Initial investment",
        "profits": "Annual profits (after tax) from sold energy",
        "energyPrice": "at annual selling price of ({{currency}}/MWh):",
        "savings": "Annual savings from produced GOs",
        "total": "Total profits (after tax) + savings"
      },
      "vp": {
        "title": "Explore the benefits",
        "labels": {
          "riduzione-prevedibile": "Cost reduction",
          "ebitda": "EBITDA uplift",
          "conformita": "SBTi compliance",
          "copertura-naturale": "Natural hedge",
          "impatto": "Marketable impact"
        },
        "riduzione": {
          "title": "The net energy cost with DEC",
          "total": "Total costs",
          "goValue": "GO value",
          "revenueShare": "Energy revenue share",
          "net": "Net cost",
          "goCost": "GO cost",
          "energyCost": "Energy cost",
          "disclaimer": "Energy and GO costs estimated over the contract horizon; proportions are indicative."
        },
        "ebitda": {
          "title": "The EBITDA uplift with DEC",
          "baseline": "Current EBITDA",
          "baselineNote": "illustrative",
          "goSaving": "GO saving",
          "energyRevenue": "Energy revenue",
          "result": "EBITDA with DEC Energy",
          "disclaimer": "Current EBITDA is illustrative; the uplift reflects the calculated values. The GO saving may not be shown to scale. Under the IAS/IFRS international accounting standards, the DEC Energy transaction increases EBITDA."
        },
        "conformita": {
          "title": "The cost of SBTi-compliant GOs",
          "yAxis": "SBTi-compliant GO price",
          "time": "TIME",
          "market": "GOs without DEC Energy",
          "marketNote": "hypothetical, not to scale",
          "zero": "GO cost zeroed",
          "dec": "GOs with DEC Energy"
        },
        "copertura": {
          "title": "Spend vs revenue, year by year",
          "spend": "Energy spend",
          "revenue": "Plant revenue",
          "net": "Net cost",
          "year": "Year",
          "correlation": "The assumed correlation between the change in the market energy purchase price and the plant's energy selling price is {{pct}}%",
          "disclaimer": "Illustrative chart; DEC revenue tracks the price and flattens the net cost."
        },
        "impatto": {
          "title": "Marketable impact",
          "type": "Agrivoltaics",
          "co2": "CO₂ avoided",
          "co2Note": "estimate (0.4 t/MWh)",
          "crops": "Crops protected",
          "cropsValue": "hail and heat",
          "water": "Water saved",
          "waterUnit": "m³/year",
          "yield": "Crop yield",
          "yieldValue": "+ 20%"
        }
      }
    },
    "restart": "Select another plant",
    "switch": "Try another plant",
    "switchNote": "the PDF is not sent again automatically",
    "select": "Select",
    "backToInputs": "Edit inputs"
  },
  "year": "year"
}
